<template>
  <div class="realtime-container" :class="'isMore' + isMore">
    <div class="top-map" ref="topMap">
      <div class="maps-change">
        <el-radio-group v-model="mapType" size="mini" @change="changeMap">
          <el-radio-button label="tdt">{{ $t('operate.name74') }}</el-radio-button>
          <el-radio-button label="google">{{ $t('operate.name73') }}</el-radio-button>
        </el-radio-group>
      </div>
      <div v-show="isMore !== 2" class="search-view">
        <el-select v-model="curPoint" filterable clearable :placeholder="$t('operate.name80')" @change="changeMarker">
          <el-option v-for="item in points" :key="item.ebikeId" :label="item.ebikeId" :value="item.ebikeId" />
        </el-select>
      </div>
      <div v-if="mapType === 'tdt'" class="map-item">
        <div id="mapDiv" class="map"></div>
        <div id="mapHotDiv" class="hot-map"></div>
      </div>
      <GmapMap
        v-if="mapType === 'google'"
        :center="gmapInitCenter"
        :zoom="gmapInitZoom"
        :options="googleMapOptions"
        class="map-item google-main-map"
        ref="mapRef"
        @click="closeVehiclePanel"
        @dragstart="handleGoogleMapDragStart"
      >
        <gmap-cluster
          :grid-size="30"
          :zoom-on-click="true"
          @click="onGoogleClusterClick"
        >
          <gmap-marker
            v-for="(item, index) in googleMarkers"
            :key="item.ebikeId || index"
            :position="{ lng: Number(item.lng), lat: Number(item.lat) }"
            :icon="item.status === 0 ? bikeredIcon : bikeblueIcon"
            :clickable="true"
            @click="infowindowgoole(item, index)"
          />
        </gmap-cluster>
      </GmapMap>
      <VehicleMapInfoPanel
        :visible="vehiclePanelVisible"
        :vehicles="vehiclePanelGroup"
        :index="vehiclePanelIndex"
        :position="vehiclePanelPosition"
        @close="closeVehiclePanel"
        @prev="showPrevVehicle"
        @next="showNextVehicle"
      />
      <HeatMap
        :key="googleHeatmapKey"
        class="hot-gmap"
        v-if="mapType === 'google' && hotmarkersgoole.length > 0"
        :initialZoom="4"
        :points="hotmarkersgoole"
        :lat="mapCenterHot.lat"
        :lng="mapCenterHot.lng"
        :maxIntensity="googleHeatMaxIntensity"
      />
      <MapRemoteControls
        class="map-remote-controls-wrap"
        @pan="panMap"
        @fullscreen="toggleMapFullscreen"
      />
      <div
        v-if="mapType === 'google'"
        class="google-map-zoom-controls"
      >
        <button type="button" class="google-map-zoom-btn" @click="changeGoogleZoom(1)">+</button>
        <button type="button" class="google-map-zoom-btn" @click="changeGoogleZoom(-1)">−</button>
      </div>
    </div>
    <div class="open-view">
      <el-button v-show="isMore !== 1" icon="el-icon-arrow-down" type="info" size="mini" @click="changeMore(1)" />
      <el-button v-show="isMore !== 2" icon="el-icon-arrow-up" type="info" size="mini" @click="changeMore(2)" />
    </div>
    <div class="bottom-list">
      <div class="tabs">
        <div
          v-for="item in tabs"
          :key="item.type"
          class="tabs-item"
          :class="activeName === item.type ? 'active' : ''"
          @click="handleClick(item)"
        >
          {{ item.label }}（{{ item.value }}）
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="warnList"
        height="calc(100% - 40px)"
        :highlight-current-row="true"
        @row-click="clickMarker"
      >
        <el-table-column :label="$t('finance.name40')" align="center" prop="tenantName" />
        <el-table-column :label="$t('finance.name28')" align="center" prop="ebikeId" />
        <el-table-column :label="$t('bike.name40')" align="center" prop="mac" />
        <el-table-column :label="$t('bike.name43')" align="center" prop="controllerVersion" />
        <el-table-column :label="$t('bike.name106')" align="center" prop="meterVersion" />
        <el-table-column :label="$t('bike.name107')" align="center" prop="iotVersionNo" />
        <el-table-column :label="$t('home.name26')" align="center" prop="soc" />
        <el-table-column :label="$t('bike.name225')" align="center" prop="lockStatus">
          <template slot-scope="scope">
            {{ [$t('home.name28'), $t('home.name29')][scope.row.lockStatus] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('home.name27')" align="center" prop="status">
          <template slot-scope="scope">
            {{ [$t('bike.name113'), $t('bike.name228'), $t('home.name30')][scope.row.status] }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
// 实时 GIS 无时间筛选，后续若增加需走 $tz 工具
import { findEbikeNewGisProfileList } from '@/api/realtime.js'
import { mapGetters } from 'vuex'
import GmapCluster from 'vue2-google-maps/src/components/cluster'
import { toMapLngLat } from '@/utils/mapCoords'
import HeatMap from '@/components/HeatMap'
import MapRemoteControls from '@/components/MapRemoteControls'
import VehicleMapInfoPanel from '@/components/VehicleMapInfoPanel'
import { buildNearbyVehicleGroup } from '@/utils/mapVehicleNeighbors'
import { resolvePanelPosition } from '@/utils/mapScreenPosition'
import { defaultMapType } from '@/config/flavor'

const DEFAULT_MAP_CENTER = { lng: 116.4074, lat: 39.9042 }

export default {
  computed: {
    ...mapGetters(['userinfo']),
    tabs () {
      return [
        { label: this.$t('home.name23'), type: 'all', value: this.allPoints.length },
        { label: this.$t('home.name24'), type: 'online', value: this.onlineList.length },
        { label: this.$t('home.name25'), type: 'error', value: this.faultList.length },
      ]
    },
    googleMarkers () {
      return this.points.filter((item) => item.lng != null && item.lat != null)
    },
    googleHeatmapKey () {
      return `${this.activeName}-${this.hotmarkersgoole.length}`
    },
    googleHeatMaxIntensity () {
      if (!this.hotmarkersgoole.length) return 3
      const maxCount = Math.max(...this.hotmarkersgoole.map((item) => item.count || 1))
      return Math.max(3, maxCount)
    },
  },
  components: {
    GmapCluster,
    HeatMap,
    MapRemoteControls,
    VehicleMapInfoPanel,
  },
  data () {
    return {
      loading: false,
      curPoint: '',
      // 缺省来自 flavor：国内 tdt / 海外 google（含海外测试服）；用户仍可切换
      mapType: defaultMapType,
      googleMapOptions: {
        gestureHandling: 'greedy',
        scrollwheel: true,
        draggable: true,
        disableDefaultUI: true,
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      },
      mapGZoom: 5,
      gmapInitCenter: { lat: 39.9042, lng: 116.4074 },
      gmapInitZoom: 5,
      mapCenterHot: { ...DEFAULT_MAP_CENTER },
      hotmarkersgoole: [],
      vehiclePanelVisible: false,
      vehiclePanelGroup: [],
      vehiclePanelIndex: 0,
      vehiclePanelPosition: { left: 0, top: 0 },
      points: [],
      allPoints: [],
      hotmarkersTdt: [],
      maxHot: 0,
      activeName: 'all',
      bikeblueIcon: {
        url: require('@/assets/bikeblue.png'),
        size: { width: 50, height: 30 },
        scaledSize: { width: 50, height: 30 },
      },
      bikeredIcon: {
        url: require('@/assets/bikered.png'),
        size: { width: 50, height: 30 },
        scaledSize: { width: 50, height: 30 },
      },
      isMore: 0,
      warnList: [],
      onlineList: [],
      faultList: [],
      mapTD: null,
      T: null,
      markers: null,
      allMarkers: [],
      heatmapOverlay: null,
      mapHotDiv: null,
      tdtZoomHandler: null,
      tdtMapClickHandler: null,
      tdtDragHandler: null,
      tdtMoveCloseSuppressed: false,
      tdtMoveCloseReleaseTimer: null,
      googleMapCloseSuppressed: false,
      googleMapCloseReleaseTimer: null,
    }
  },
  created () {
    this.handleLangChange = () => {
      this.renderMapForActiveList()
    }
    this.$bus.$on('lang', this.handleLangChange)
  },
  mounted () {
    document.addEventListener('fullscreenchange', this.handleMapFullscreenChange)
    this.getPoints()
  },
  beforeDestroy () {
    this.$bus.$off('lang', this.handleLangChange)
    document.removeEventListener('fullscreenchange', this.handleMapFullscreenChange)
    if (this.tdtMoveCloseReleaseTimer) {
      clearTimeout(this.tdtMoveCloseReleaseTimer)
    }
    if (this.googleMapCloseReleaseTimer) {
      clearTimeout(this.googleMapCloseReleaseTimer)
    }
    this.destroyTdtMaps()
  },
  methods: {
    getGoogleMap () {
      const mapRef = this.$refs.mapRef
      if (!mapRef) return Promise.resolve(null)
      return mapRef.$mapPromise
    },
    changeGoogleZoom (delta) {
      const mapRef = this.$refs.mapRef
      if (!mapRef) {
        this.mapGZoom = Math.min(22, Math.max(3, this.mapGZoom + delta))
        return
      }
      mapRef.$mapPromise.then((map) => {
        const nextZoom = Math.min(22, Math.max(3, map.getZoom() + delta))
        map.setZoom(nextZoom)
        this.mapGZoom = nextZoom
      }).catch(() => {
        this.mapGZoom = Math.min(22, Math.max(3, this.mapGZoom + delta))
      })
    },
    panMap (direction) {
      this.closeVehiclePanel()
      const offset = 120
      const deltas = {
        up: [0, -offset],
        down: [0, offset],
        left: [-offset, 0],
        right: [offset, 0],
      }
      const delta = deltas[direction]
      if (!delta) return
      const [dx, dy] = delta
      if (this.mapType === 'tdt') {
        if (!this.mapTD || !this.T) return
        if (typeof this.mapTD.panBy === 'function') {
          this.mapTD.panBy(new this.T.Point(dx, dy))
        }
        return
      }
      const mapRef = this.$refs.mapRef
      if (!mapRef) return
      mapRef.$mapPromise.then((map) => {
        map.panBy(dx, dy)
      }).catch(() => {})
    },
    toggleMapFullscreen () {
      const el = this.$refs.topMap
      if (!el) return
      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
        return
      }
      if (el.requestFullscreen) {
        el.requestFullscreen()
      }
    },
    handleMapFullscreenChange () {
      this.$nextTick(() => {
        if (this.mapType === 'tdt') {
          if (typeof this.mapTD?.checkResize === 'function') {
            this.mapTD.checkResize()
          }
          if (typeof this.mapHotDiv?.checkResize === 'function') {
            this.mapHotDiv.checkResize()
          }
          return
        }
        const map = this.$refs.mapRef?.$mapObject
        const google = window.google
        if (map && google?.maps) {
          google.maps.event.trigger(map, 'resize')
        }
      })
    },
    normalizeList (list, extraKeepKeys = []) {
      const keepKeys = ['lng', 'lat', 'status', 'lockStatus', 'batteryTemp', 'batteryTemperatureShowDeviation', ...extraKeepKeys]
      return (list || []).map((item) => {
        const row = { ...item }
        Object.keys(row).forEach((k) => {
          if (!keepKeys.includes(k)) {
            row[k] = row[k] || '--'
          }
        })
        return row
      })
    },
    getActiveDataList () {
      if (this.activeName === 'online') return this.onlineList
      if (this.activeName === 'error') return this.faultList
      return this.allPoints
    },
    buildHeatmapData (dataList) {
      const hots = new Map()
      dataList.forEach((item) => {
        if (item.lng == null || item.lat == null) return
        const key = `${item.lng},${item.lat}`
        if (hots.has(key)) {
          hots.get(key).count += 1
        } else {
          hots.set(key, { lng: item.lng, lat: item.lat, count: 1 })
        }
      })
      return Array.from(hots.values())
    },
    suppressTdtMoveClose (durationMs = 400) {
      this.tdtMoveCloseSuppressed = true
      if (this.tdtMoveCloseReleaseTimer) {
        clearTimeout(this.tdtMoveCloseReleaseTimer)
      }
      this.tdtMoveCloseReleaseTimer = setTimeout(() => {
        this.tdtMoveCloseSuppressed = false
        this.tdtMoveCloseReleaseTimer = null
      }, durationMs)
    },
    suppressGoogleMapClose (durationMs = 400) {
      this.googleMapCloseSuppressed = true
      if (this.googleMapCloseReleaseTimer) {
        clearTimeout(this.googleMapCloseReleaseTimer)
      }
      this.googleMapCloseReleaseTimer = setTimeout(() => {
        this.googleMapCloseSuppressed = false
        this.googleMapCloseReleaseTimer = null
      }, durationMs)
    },
    handleGoogleMapDragStart () {
      if (this.googleMapCloseSuppressed) return
      this.closeVehiclePanel()
    },
    handleTdtMapMoveStart () {
      if (this.tdtMoveCloseSuppressed) return
      this.closeVehiclePanel()
    },
    async openVehiclePanel (anchor, position) {
      const lng = Number(position?.lng ?? anchor.lng)
      const lat = Number(position?.lat ?? anchor.lat)
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
      if (!this.points.length) return
      if (this.mapTD && typeof this.mapTD.closeInfoWindow === 'function') {
        this.mapTD.closeInfoWindow()
      }
      const group = buildNearbyVehicleGroup(this.points, { ...anchor, lng, lat })
      if (!group.length) return
      const idx = group.findIndex((item) => item.ebikeId === anchor.ebikeId)
      this.vehiclePanelGroup = group
      this.vehiclePanelIndex = idx >= 0 ? idx : 0
      this.vehiclePanelVisible = true
      this.curPoint = group[this.vehiclePanelIndex].ebikeId
      await this.updateVehiclePanelPosition(lng, lat)
    },
    closeVehiclePanel () {
      this.vehiclePanelVisible = false
      this.vehiclePanelGroup = []
      this.vehiclePanelIndex = 0
      this.vehiclePanelPosition = { left: 0, top: 0 }
    },
    async updateVehiclePanelPosition (lng, lat) {
      const topMapEl = this.$refs.topMap
      let googleMap = null
      if (this.mapType === 'google' && this.$refs.mapRef) {
        try {
          googleMap = await this.$refs.mapRef.$mapPromise
        } catch (e) { /* ignore */ }
      }
      this.vehiclePanelPosition = await resolvePanelPosition({
        mapType: this.mapType,
        lng,
        lat,
        topMapEl,
        mapTD: this.mapTD,
        T: this.T,
        googleMap,
      })
    },
    showPrevVehicle () {
      if (this.vehiclePanelGroup.length <= 1) return
      this.vehiclePanelIndex = (this.vehiclePanelIndex - 1 + this.vehiclePanelGroup.length) % this.vehiclePanelGroup.length
      this.syncPanelVehicleSelection()
    },
    showNextVehicle () {
      if (this.vehiclePanelGroup.length <= 1) return
      this.vehiclePanelIndex = (this.vehiclePanelIndex + 1) % this.vehiclePanelGroup.length
      this.syncPanelVehicleSelection()
    },
    syncPanelVehicleSelection () {
      const item = this.vehiclePanelGroup[this.vehiclePanelIndex]
      if (!item) return
      this.curPoint = item.ebikeId
      const lng = Number(item.lng)
      const lat = Number(item.lat)
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
      this.updateVehiclePanelPosition(lng, lat)
    },
    refreshVehiclePanelAfterDataChange () {
      if (!this.vehiclePanelVisible || !this.vehiclePanelGroup.length) return
      const current = this.vehiclePanelGroup[this.vehiclePanelIndex]
      if (!current) {
        this.closeVehiclePanel()
        return
      }
      const stillExists = this.points.find((item) => item.ebikeId === current.ebikeId)
      if (!stillExists) {
        this.closeVehiclePanel()
        return
      }
      const group = buildNearbyVehicleGroup(this.points, stillExists)
      if (!group.length) {
        this.closeVehiclePanel()
        return
      }
      const idx = group.findIndex((item) => item.ebikeId === stillExists.ebikeId)
      this.vehiclePanelGroup = group
      this.vehiclePanelIndex = idx >= 0 ? idx : 0
      this.curPoint = group[this.vehiclePanelIndex].ebikeId
      const lng = Number(stillExists.lng)
      const lat = Number(stillExists.lat)
      if (Number.isFinite(lng) && Number.isFinite(lat)) {
        this.updateVehiclePanelPosition(lng, lat)
      }
    },
    changeMore (tag) {
      if (tag === 1) {
        this.isMore = this.isMore === 0 ? 1 : 0
      } else {
        this.isMore = this.isMore === 0 ? 2 : 0
      }
    },
    getPoints () {
      this.loading = true
      findEbikeNewGisProfileList({})
        .then((res) => {
          this.allPoints = this.normalizeList(res?.data?.allList || [])
          this.onlineList = this.normalizeList(res?.data?.onlineList || [])
          this.faultList = this.normalizeList(res?.data?.faultList || [])
          this.renderMapForActiveList()
        })
        .catch(() => {
          this.allPoints = []
          this.onlineList = []
          this.faultList = []
          this.warnList = []
          this.points = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    renderMapForActiveList () {
      const dataList = this.getActiveDataList()
      if (this.mapType === 'tdt') {
        this.refreshTdtView(dataList)
      } else {
        this.initGoogleMap(dataList)
      }
    },
    refreshTdtView (dataList, attempt = 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.mapType !== 'tdt') return
          if (this.initTdtMaps()) {
            this.setTDTMarker(dataList)
            return
          }
          if (attempt < 6) {
            this.refreshTdtView(dataList, attempt + 1)
          }
        }, attempt === 0 ? 80 : 180)
      })
    },
    initTdtMaps () {
      if (!window.T) return false
      const mainContainer = document.getElementById('mapDiv')
      const hotContainer = document.getElementById('mapHotDiv')
      if (!mainContainer || !hotContainer) return false
      if (mainContainer.offsetWidth === 0 || mainContainer.offsetHeight === 0) return false

      // v-if 切走 Google 后 DOM 会重建，旧 map 实例已失效
      if (this.mapTD && !mainContainer.childNodes.length) {
        this.destroyTdtMaps()
      }

      this.T = window.T
      if (!this.mapTD) {
        this.mapTD = new this.T.Map('mapDiv', {
          attributionControl: true,
          inertia: true,
        })
        this.mapTD.addControl(new this.T.Control.Zoom())
        this.tdtZoomHandler = () => this.handleTdtZoomEnd()
        this.mapTD.addEventListener('zoomend', this.tdtZoomHandler)
        this.tdtMapClickHandler = () => this.closeVehiclePanel()
        this.tdtDragHandler = () => this.handleTdtMapMoveStart()
        this.mapTD.addEventListener('click', this.tdtMapClickHandler)
        this.mapTD.addEventListener('movestart', this.tdtDragHandler)
      }
      if (!this.mapHotDiv) {
        this.mapHotDiv = new this.T.Map('mapHotDiv')
        this.heatmapOverlay = new this.T.HeatmapOverlay({ radius: 30 })
      }
      if (typeof this.mapTD.checkResize === 'function') {
        this.mapTD.checkResize()
      }
      if (typeof this.mapHotDiv.checkResize === 'function') {
        this.mapHotDiv.checkResize()
      }
      return true
    },
    destroyTdtMaps () {
      if (this.mapTD && this.tdtZoomHandler) {
        this.mapTD.removeEventListener('zoomend', this.tdtZoomHandler)
      }
      if (this.mapTD && this.tdtMapClickHandler) {
        this.mapTD.removeEventListener('click', this.tdtMapClickHandler)
      }
      if (this.mapTD && this.tdtDragHandler) {
        this.mapTD.removeEventListener('movestart', this.tdtDragHandler)
      }
      if (this.markers) {
        try {
          this.markers.clearMarkers()
        } catch (e) { /* ignore */ }
        this.markers = null
      }
      this.allMarkers = []
      this.mapTD = null
      this.mapHotDiv = null
      this.heatmapOverlay = null
      this.tdtZoomHandler = null
      this.tdtMapClickHandler = null
      this.tdtDragHandler = null
    },
    handleTdtZoomEnd () {
      if (!this.mapTD || !this.allMarkers.length) return
      const zoom = this.mapTD.getZoom()
      if (zoom >= 18) {
        if (this.markers) {
          this.markers.clearMarkers()
          this.markers = null
        }
        this.allMarkers.forEach((marker) => {
          this.mapTD.addOverLay(marker)
        })
      } else if (!this.markers) {
        this.allMarkers.forEach((marker) => {
          try {
            this.mapTD.removeOverLay(marker)
          } catch (e) { /* ignore */ }
        })
        this.markers = new this.T.MarkerClusterer(this.mapTD, {
          markers: this.allMarkers,
          gridSize: 30,
        })
      }
    },
    initGoogleMap (dataList) {
      this.hotmarkersgoole = []
      this.warnList = dataList.map((item) => {
        const row = { ...item }
        if (row.lng != null && row.lat != null) {
          const pt = toMapLngLat(Number(row.lng), Number(row.lat), 'google')
          if (pt) {
            row.lng = pt.lng
            row.lat = pt.lat
          }
        }
        return row
      })
      this.points = this.warnList.filter((row) =>
        row.lng != null && row.lat != null && !Number.isNaN(Number(row.lng)) && !Number.isNaN(Number(row.lat))
      )
      this.hotmarkersgoole = this.buildHeatmapData(this.points)
      const center = this.computePointsCenter(this.points)
      this.mapCenterHot = center
      this.scheduleGoogleMapFit()
      this.refreshVehiclePanelAfterDataChange()
    },
    computePointsCenter (points) {
      if (!points.length) return { ...DEFAULT_MAP_CENTER }
      let lngSum = 0
      let latSum = 0
      let count = 0
      points.forEach((p) => {
        const lng = Number(p.lng)
        const lat = Number(p.lat)
        if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
        lngSum += lng
        latSum += lat
        count += 1
      })
      if (!count) return { ...DEFAULT_MAP_CENTER }
      return { lng: lngSum / count, lat: latSum / count }
    },
    scheduleGoogleMapFit (attempt = 0) {
      this.$nextTick(() => {
        setTimeout(async () => {
          if (this.mapType !== 'google') return
          const ok = await this.fitGoogleMapBounds()
          if (!ok && attempt < 6) {
            this.scheduleGoogleMapFit(attempt + 1)
          }
        }, attempt === 0 ? 120 : 200)
      })
    },
    fitGoogleMapBounds () {
      if (!this.points.length) {
        return this.getGoogleMap().then((map) => {
          if (!map) return false
          map.setCenter(DEFAULT_MAP_CENTER)
          map.setZoom(5)
          return true
        })
      }
      return this.getGoogleMap().then((map) => {
        const google = window.google
        if (!map || !google?.maps) return false
        const bounds = new google.maps.LatLngBounds()
        this.points.forEach((p) => {
          bounds.extend(new google.maps.LatLng(Number(p.lat), Number(p.lng)))
        })
        map.fitBounds(bounds, 50)
        google.maps.event.addListenerOnce(map, 'idle', () => {
          this.syncGoogleHeatmapCenter(map)
        })
        return true
      }).catch(() => false)
    },
    syncGoogleHeatmapCenter (map) {
      if (!map) return
      const center = map.getCenter()
      if (!center) return
      this.mapCenterHot = {
        lat: center.lat(),
        lng: center.lng(),
      }
    },
    onGoogleClusterClick (cluster) {
      if (!cluster || typeof cluster.getBounds !== 'function') return
      this.getGoogleMap().then((map) => {
        const google = window.google
        if (!map) return
        const bounds = cluster.getBounds()
        map.fitBounds(bounds, 50)
        if (google?.maps) {
          google.maps.event.addListenerOnce(map, 'idle', () => {
            this.syncGoogleHeatmapCenter(map)
          })
        }
      })
    },
    infowindowgoole (item) {
      const lng = Number(item.lng)
      const lat = Number(item.lat)
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
      this.openVehiclePanel(item, { lng, lat })
    },
    addClickHandler (item, marker, that) {
      marker.addEventListener('click', function (e) {
        if (e?.originalEvent?.stopPropagation) {
          e.originalEvent.stopPropagation()
        }
        that.openVehiclePanel(item, { lng: e.lnglat.lng, lat: e.lnglat.lat })
      })
    },
    clearTdtMarkers () {
      if (this.markers) {
        this.markers.clearMarkers()
        this.markers = null
      }
      if (this.mapTD && this.allMarkers.length) {
        this.allMarkers.forEach((marker) => {
          try {
            this.mapTD.removeOverLay(marker)
          } catch (e) { /* ignore */ }
        })
      }
      this.allMarkers = []
    },
    setTDTMarker (dataList) {
      if (!this.mapTD || !this.T) return
      this.points = dataList.filter((item) => item.lng != null && item.lat != null)
      this.warnList = this.points
      if (this.points.length > 0) {
        const lng = Number(this.points[0].lng)
        const lat = Number(this.points[0].lat)
        this.mapCenterHot = Number.isFinite(lng) && Number.isFinite(lat)
          ? { lng, lat }
          : { ...DEFAULT_MAP_CENTER }
      } else {
        this.mapCenterHot = { ...DEFAULT_MAP_CENTER }
      }
      this.hotmarkersTdt = this.buildHeatmapData(this.points)
      this.maxHot = this.hotmarkersTdt.length
        ? Math.max(...this.hotmarkersTdt.map((item) => item.count))
        : 0
      this.clearTdtMarkers()
      this.initTDT(this.mapCenterHot.lng, this.mapCenterHot.lat)
      this.setMapOverlay()
      this.refreshVehiclePanelAfterDataChange()
    },
    setMapOverlay () {
      if (!this.mapHotDiv || !this.heatmapOverlay) return
      this.mapHotDiv.centerAndZoom(new this.T.LngLat(this.mapCenterHot.lng, this.mapCenterHot.lat), 4)
      this.mapHotDiv.clearOverLays()
      this.mapHotDiv.addOverLay(this.heatmapOverlay)
      this.heatmapOverlay.setDataSet({ data: this.hotmarkersTdt, max: this.maxHot || 1 })
    },
    initTDT (lng, lat) {
      this.mapTD.centerAndZoom(new this.T.LngLat(lng, lat), 5)
      const arrayObj = []
      for (let i = 0; i < this.points.length; i++) {
        const point = this.points[i]
        const iconUrl = point.status === 0
          ? require('@/assets/bikered.png')
          : require('@/assets/bikeblue.png')
        const marker = new this.T.Marker(
          new this.T.LngLat(point.lng, point.lat),
          {
            icon: new this.T.Icon({
              iconUrl,
              iconSize: new this.T.Point(50, 30),
            }),
          },
        )
        this.addClickHandler(point, marker, this)
        arrayObj.push(marker)
      }
      this.allMarkers = arrayObj
      if (arrayObj.length) {
        this.markers = new this.T.MarkerClusterer(this.mapTD, {
          markers: arrayObj,
          gridSize: 30,
        })
      }
    },
    changeMap () {
      this.closeVehiclePanel()
      this.curPoint = ''
      if (this.mapType === 'google') {
        this.destroyTdtMaps()
        this.renderMapForActiveList()
        return
      }
      // 从 Google 切回天地图：DOM 由 v-if 重新挂载，必须销毁旧实例后重建
      this.destroyTdtMaps()
      this.refreshTdtView(this.getActiveDataList())
    },
    handleClick (item) {
      if (item.type === this.activeName) return
      this.warnList = []
      this.closeVehiclePanel()
      this.curPoint = ''
      this.activeName = item.type
      this.renderMapForActiveList()
    },
    changeMarker (ebikeId) {
      if (!ebikeId) return
      const target = this.points.find((item) => item.ebikeId === ebikeId)
      if (!target) return
      const lng = Number(target.lng)
      const lat = Number(target.lat)
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
      if (this.mapType === 'tdt') {
        if (!this.mapTD || !this.T) return
        this.suppressTdtMoveClose()
        this.mapTD.centerAndZoom(new this.T.LngLat(lng, lat), 18)
        this.openVehiclePanel(target, { lng, lat })
      } else {
        this.suppressGoogleMapClose()
        this.getGoogleMap().then((map) => {
          if (!map) return
          map.setCenter({ lat, lng })
          map.setZoom(18)
        })
        this.openVehiclePanel(target, { lng, lat })
      }
    },
    clickMarker (item) {
      this.changeMarker(item.ebikeId)
    },
  },
}
</script>
<style lang="scss" scoped>
.realtime-container {
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .open-view {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 40%;

    .el-button {
      width: 120px;
      height: 15px;
      line-height: 15px;
      padding: 0;
    }
  }

  .top-map {
    height: 60%;
    position: relative;

    .search-view {
      position: absolute;
      top: 50px;
      left: 50px;
      z-index: 9999;
    }

    .maps-change {
      position: absolute;
      top: 10px;
      left: 50px;
      z-index: 9999;
    }

    .map-remote-controls-wrap {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 10001;
    }

    .hot-gmap {
      position: absolute;
      width: 200px !important;
      height: 200px !important;
      bottom: 0;
      right: 0;
      z-index: 10;
      border: 1px solid #000;
      pointer-events: none;
    }

    .google-map-zoom-controls {
      position: absolute;
      left: 10px;
      top: 10px;
      right: auto;
      z-index: 10001;
      display: flex;
      flex-direction: column;
      gap: 0;
      pointer-events: auto;

      .google-map-zoom-btn {
        width: 29px;
        height: 29px;
        padding: 0;
        border: 1px solid #ccc;
        border-radius: 0;
        background: #fff;
        color: #333;
        font-size: 18px;
        line-height: 27px;
        cursor: pointer;
        box-shadow: none;

        &:first-child {
          border-bottom: none;
        }

        &:hover {
          background: #f5f5f5;
        }
      }
    }

    .map-item {
      width: 100%;
      height: 100%;
      position: relative;

      .map {
        width: 100%;
        height: 100%;
      }

      .hot-map {
        position: absolute;
        width: 200px;
        height: 200px;
        bottom: 0;
        right: 0;
        z-index: 9999;
        border: 1px solid #000;
      }
    }
  }

  .bottom-list {
    height: 40%;

    .tabs {
      display: flex;
      align-items: center;
      height: 30px;
      padding: 1px 0;

      &-item {
        padding: 0 50px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;

        &.active {
          color: #0f73e6;
          border-bottom: 1px solid #0f73e6;
        }
      }
    }

    .el-table {
      margin-top: 0 !important;
    }
  }

  &.isMore1 {
    .open-view {
      bottom: 0;
    }

    .top-map {
      height: calc(100% - 15px);
    }

    .bottom-list {
      height: 0;
    }
  }

  &.isMore2 {
    .open-view {
      bottom: auto;
      top: 0;
    }

    .top-map {
      height: 0;
    }

    .bottom-list {
      height: 100%;
    }
  }
}

</style>
